import 'intersection-observer'; // IntersectionObserver polyfill
import { forEachEl, noop } from './utils';
import RespContent from './resp-content';

let observer = null;

export function init() {
  const lazyElements = document.querySelectorAll('.lazy');
  observer = new IntersectionObserver(handleIntersectionChange);
  forEachEl(lazyElements, el => observer.observe(el));
}

function handleIntersectionChange(entries) {
  entries.forEach(entry => {
    if (entry.intersectionRatio > 0) {
      const el = entry.target;
      getHandler(el)(el);
      observer && observer.unobserve(el);
    }
  });
}

function getHandler(el) {
  if (el.classList.contains('resp-content') || el.classList.contains('resp-image')) {
    return RespContent.updateElement;
  }

  switch (el.tagName.toUpperCase()) {
    case 'VIDEO':
      return handleVideo;
    case 'IMG':
      return handleImage;
    default:
      return noop;
  }
}

function handleVideo(el) {
  const sources = el.querySelectorAll('source');
  forEachEl(sources, source => {
    const src = source.getAttribute('data-src');
    source.setAttribute('src', src);
  });
  el.load();
  el.classList.remove('lazy');
}

function handleImage(el) {
  const src = el.getAttribute('data-src');
  el.setAttribute('src', src);
  el.classList.remove('lazy');
}

export default {
  init
};